import { axios } from "../../../core/axios";
import { AllowedDealersResponse, Dealer, FetchAllowedDealersParams, GetDealerContractedProductsResponse } from "../types";

export async function fetchAllowedDealers({ date, isRollup = false, productNames }: FetchAllowedDealersParams): Promise<Dealer[]> {
    const query = new URLSearchParams({
        date,
        isRollup: String(isRollup),
    });
    if (productNames && productNames.length > 0) query.set("productNames", productNames.join(","));

    const response = await axios.get<{ data: AllowedDealersResponse }>(`/get-allowed-dealers?${query.toString()}`);
    return response.data.data.sort((a, b) => a.dealerName.localeCompare(b.dealerName));
}

export async function fetchAllowedProducts(): Promise<string[]> {
    const response = await axios.get<{ data: string[] }>("/get-allowed-products");
    return (response.data.data ?? []).filter((p): p is string => typeof p === "string" && p.length > 0).sort((a, b) => a.localeCompare(b));
}

export async function getDealerContractedProducts(dealerRefId: string, dateFrom?: string, dateTo?: string) {
    try {
        const query = new URLSearchParams();
        if (dateFrom) query.set("dateFrom", dateFrom);
        if (dateTo) query.set("dateTo", dateTo);
        const queryString = query.toString();
        const response = await axios.get(`/get-dealer-contracted-products/${dealerRefId}${queryString ? `?${queryString}` : ""}`);
        return response.data as GetDealerContractedProductsResponse;
    } catch (error) {
        console.error("Error fetching dealer contracted products:", error);
        return;
    }
}
